import produce from 'immer';
import { isEmpty } from 'lodash';
import PAGES from 'constants/pages';
import {
  LOAD_DATA,
  LOAD_DATA_SUCCESS,
  LOAD_DATA_ERROR,
  RESET_DATA,
  TOGGLE_FAVORITE_STATUS_SUCCESS,
} from './action-types';
import { detailsParamsToKey, getDataFromPageTab } from './helpers';
import { PageBaseShapeType, DetailsShapeType } from './types';

export type PagesStateType = {
  DETAILS?: {
    [key: string]: DetailsShapeType;
  };
};

const pageBaseShape: PageBaseShapeType = {
  isLoading: true,
  data: null,
  error: null,
};

const initialState: PagesStateType = {};

export default produce((draft: PagesStateType, action) => {
  switch (action.type) {
    case LOAD_DATA: {
      const { pageId, params } = action.payload;

      if (pageId === PAGES.DETAILS) {
        draft[pageId] = draft[pageId] || {};
        draft[pageId][detailsParamsToKey(params)] = { ...pageBaseShape };
      } else if ([PAGES.VOD, PAGES.MY_WATCHLIST].includes(pageId) && params.tabId) {
        const tabData = getDataFromPageTab(draft, pageId, params.tabId);
        if (!params.offset) {
          tabData.content = { ...pageBaseShape };
          tabData.content.data = [];
        } else {
          tabData.content.isOnLazyLoad = true;
          tabData.content.isAllItemsLoaded = false;
        }
      } else if (pageId === PAGES.LIVE_TV) {
        if (!params.offset) {
          draft[pageId] = { ...pageBaseShape, data: {} };
        } else {
          draft[pageId].isOnLazyLoad = true;
          draft[pageId].isAllItemsLoaded = false;
        }
      } else {
        draft[pageId] = { ...pageBaseShape };
      }
      break;
    }
    case LOAD_DATA_SUCCESS: {
      const { pageId, params, data } = action.payload;

      if (pageId === PAGES.DETAILS) {
        draft[pageId][detailsParamsToKey(params)].isLoading = false;
        draft[pageId][detailsParamsToKey(params)].data = data;
      } else if ([PAGES.VOD, PAGES.MY_WATCHLIST].includes(pageId) && params.tabId) {
        const tabData = getDataFromPageTab(draft, pageId, params.tabId);
        tabData.content.isLoading = false;
        tabData.content.data = tabData.content.data.concat(data.content);
        tabData.content.offset = data.offset;
        tabData.content.isOnLazyLoad = false;
        tabData.content.isAllItemsLoaded = isEmpty(data.content);
      } else if (pageId === PAGES.LIVE_TV) {
        draft[pageId].isLoading = false;
        draft[pageId].data.offset = data.offset;
        draft[pageId].data.contentType = data.contentType;
        draft[pageId].data.content = (draft[pageId].data.content || []).concat(data.content);
        draft[pageId].data.isOnLazyLoad = false;
        draft[pageId].data.isAllItemsLoaded = isEmpty(data.content);
      } else {
        draft[pageId].isLoading = false;
        draft[pageId].data = data;
      }
      break;
    }
    case LOAD_DATA_ERROR: {
      const { pageId, params, message } = action.payload;
      if (pageId === PAGES.DETAILS) {
        draft[pageId][detailsParamsToKey(params)].isLoading = false;
        draft[pageId][detailsParamsToKey(params)].error = message;
      } else if ([PAGES.VOD, PAGES.MY_WATCHLIST].includes(pageId)) {
        const tabData = getDataFromPageTab(draft, pageId, params.tabId);
        tabData.content.isLoading = false;
        tabData.content.error = message;
      } else {
        draft[pageId].isLoading = false;
        draft[pageId].error = message;
      }
      break;
    }

    case TOGGLE_FAVORITE_STATUS_SUCCESS: {
      const { id, type, favorite } = action.payload;

      if (['movie', 'series'].includes(type)) {
        draft[PAGES.DETAILS][detailsParamsToKey({ id, type })].data.details.favorite = favorite;
      } else if (type === 'channel') {
        const channels = draft[PAGES.LIVE_TV].data.content;
        const channelIndex = channels.findIndex((channel) => channel.id === id);

        channels[channelIndex].favorite = favorite;
      }
      break;
    }
    case RESET_DATA:
      return { ...initialState };
    default:
    // nothing
  }
}, initialState);

// export type { PagesStateType }
